import { Partial } from '@40seas/entities/common';
import { CreateIdentityDto } from './create-identity.dto';

export class UpdateIdentityDto extends Partial(CreateIdentityDto) {}
